import React from "react";
import { Helmet } from "react-helmet";
import { useParams } from "react-router";
import { Redirect } from "react-router-dom";

import { PartnerDetails } from "features/PartnerDetails";
import { useIsSuperUser } from "shared/hooks/useIsSuperUser";
import { PageTitle } from "shared/ui/PageTitle";

const PartnerDetailsPage = () => {
    const { partnerId } = useParams<{ partnerId: string }>();
    const isSuperUser = useIsSuperUser();

    if (!isSuperUser) return <Redirect to="/branchesRegister/general" />;

    return (
        <>
            <Helmet title="Партнёр" />
            <PageTitle>Партнёр</PageTitle>
            <PartnerDetails partnerId={Number(partnerId)} />
        </>
    );
};

export default PartnerDetailsPage;
